import React, { useState, useRef } from "react";
import TextField from "./form/TextField";
import FeedbackButton from "./form/FeedbackButton";
import SubmitButton from "Components/layout/container/form/SubmitButton"
import TextArea from "Components/layout/container/form/TextArea";
import UploadButton from "Components/layout/container/form/UploadButton";
import Switch from "Components/layout/container/form/Switch";
import { updateGeneralPlaceablePin } from 'State/generalPlaceablePinSlice';
import { useDispatch, useSelector } from "react-redux";
import { useFirebase, useFirestore } from "react-redux-firebase";
import { toast, ToastContainer } from "react-toastify";
import { DESCRIPTION_MISSING, TITLE_MISSING } from "Errors";
import { TOAST_PROPS} from "Constants/toastProps";
import { PIN_LOCATION_MISSING, PROJECT_NOT_FOUND } from "../../../utils/constants/errors";
import { setModalVisible } from 'State/addPinModalSlice';

const storageFilePath = '/pins/';

function AddPinForm({ mapRef }) {

    const dispatch = useDispatch();
    const firestore = useFirestore();
    const firebase = useFirebase();

    const [hasProjectcode, setHasProjectcode] = useState(false);
    const placeablePin = useSelector((state) => state.generalPlaceablePin);

    const handleMissingField = (e, message) => {
        e.preventDefault();
        toast.error(message, TOAST_PROPS)
    }

    const handleFormSubmit = async (event) => {

        event.preventDefault();

        if (!placeablePin.pinLat || !placeablePin.pinLng) {
            toast.error(PIN_LOCATION_MISSING, TOAST_PROPS);
            return
        }

        let project = null
        if (event.target.code?.value) {
            project = await validateProjectcode(event.target.code.value)

            if (project === false) {
                toast.error(PROJECT_NOT_FOUND, TOAST_PROPS);
                return
            }
        }

        const newPin = {
            "is_nice_place": event.target.like.value === 'true',
            "latitude": parseFloat(placeablePin.pinLat),
            "longitude": parseFloat(placeablePin.pinLng),
            "title": event.target.title.value,
            "motivation": event.target.description.value,
            "project_id": project?.id ?? null,
            "is_private": project?.data().is_private ?? false,
            "visible_from": project?.data().end_date ?? null,
            "picture_path": null,
        }

        if (event.target.picture.files.length > 0) {
            let picture_path = storageFilePath + crypto.randomUUID();
            try {
                const pictureRef = await firebase.uploadFile(
                    picture_path,
                    event.target.picture.files[0]
                );
                pictureRef.uploadTaskSnapshot.ref.getDownloadURL()
                newPin["picture_path"] = await pictureRef.uploadTaskSnapshot.ref.getDownloadURL();
            } catch (err) {
                console.log(err)
            }
        }

        firestore.collection("Pins").add(newPin);

        handleCloseModal();
    }

    const handleCloseModal = () => {

        mapRef.current.placePin(null, null);

        dispatch(updateGeneralPlaceablePin({
            pinLat: '',
            pinLng: '',
            pinAddress: ''
        }))

        dispatch(setModalVisible(false));
    };

    const placePinByImage = ({ pinLat, pinLng }) => {
        mapRef.current.placePin(pinLat, pinLng)
    } 

    const validateProjectcode = async (projectcode) => {

        if (!projectcode) return false;

        const today = new Date().toISOString().substring(0, 10);

        try {
            let res = await firestore.get({
                collection: "Projects",
                where: [
                    ["access_code", "==", projectcode],
                    ["is_private", "==", false],
                    // As for 2022-06-26 inequality queries in Firebase can be only against one variable
                    ["end_date", ">=", today], // check if the end date of project is in the future
                ]
            })
            
            if (res.docs.length > 0 && res.docs[0].data().start_date <= today) {
                return res.docs[0]
            }

            return false
        } catch (e) {
            return false
        }
    };

    return (
        <form className="addPinForm" method="post" onSubmit={handleFormSubmit}>

            <ToastContainer position="top-left"/>

            <h1 className="headline1">Pin plaatsen</h1>

            <h2 className="headline2">Kies een locatie</h2>
            
            {!placeablePin.pinAddress ? ( 
                <p>Kies een locatie door te klikken op de kaart of door een foto te uploaden die je op locatie gemaakt hebt.</p>
            ) : (  
                <p><strong>Gekozen locatie:</strong> {placeablePin.pinAddress}</p>
            )}

            <UploadButton name="picture" placePinByImage={placePinByImage} />

            <h2 className="headline2">Wat vind je van deze locatie?</h2>
            <div className="feedbackButtonGroup">
                <FeedbackButton
                    id="likeButton"
                    className="feedbackButton"
                    name="like"
                    value={true}
                    label="Mooi"
                    defaultChecked={true}
                />
                <FeedbackButton
                    id="dislikeButton"
                    className="feedbackButton"
                    name="like"
                    value={false}
                    label="Niet zo mooi"
                />
            </div>

            <h2 className="headline2">Naam van de locatie</h2>
            <TextField
                id="titleInput"
                className="textField"
                name="title" placeholder="Naam"
                required={true}
                onInvalid={(e) => handleMissingField(e, TITLE_MISSING)}
            />

            <h2 className="headline2">Toelichting</h2>
            <TextArea
                id="descriptionInput"
                className="textField"
                name="description"
                placeholder="Toelichting"
                required={true}
                onInvalid={(e) => handleMissingField(e, DESCRIPTION_MISSING)}
            />

            <h2 className="headline2">Projectcode</h2>
            <div className="switchline">
                <Switch onChange={() => setHasProjectcode(!hasProjectcode)} /> Ik heb een projectcode ontvangen die ik wil invoeren.
            </div>
            {hasProjectcode && (
            <TextField
                id="codeInput"
                className="textField"
                name="code" placeholder="Projectcode"
            />
            )}

            <div className="actionButtons">
                <button className="backButton" onClick={handleCloseModal}>Annuleren</button>
                <SubmitButton text="Plaatsen" />
            </div>

        </form >
    )
}

export default AddPinForm;
